import axios from 'axios'

import helper from '../helpers/Variables'
import history from './history'

import { getLocalStorage, removeLocalStorageItem, saveLocalStorage } from '../helpers/LocalStorage'

const baseUrl = process.env.REACT_APP_API_CLUB_URL

export const isAuthenticated = () => getLocalStorage(helper.TOKEN_KEY) !== null

export const checkPageAccess = () => {
  const user = getLocalStorage(helper.USER_KEY)

  const { UserGroupSystemScreens } = user.UserGroup

  if (UserGroupSystemScreens && UserGroupSystemScreens.length === 1) {
    const { path } = UserGroupSystemScreens[0].SystemScreen

    return path
  }
  return false
}

export const doLogin = async (email, password) => {
  try {
    const url = `${baseUrl}login`
    const body = { email, password }

    const res = await axios.post(url, body)

    saveLocalStorage(helper.TOKEN_KEY, res.data.JWT)
    saveLocalStorage(helper.USER_KEY, res.data.user)

    return res.data.user
  } catch (e) {
    if (e.response && e.response.status === 401) {
      return { error: e.response.data }
    }
    return { error: `Ocorreu algum erro. ` }
  }
}

export const getUserScreensList = () => {
  const user = getLocalStorage(helper.USER_KEY)

  const { UserGroupSystemScreens } = user.UserGroup

  return UserGroupSystemScreens.filter(screeData => {
    return screeData.canRead || screeData.canCreate || screeData.canDelete
  })
}

export const logout = () => {
  removeLocalStorageItem(helper.USER_KEY)
  removeLocalStorageItem(helper.TOKEN_KEY)
  history.replace('/')
}

export const getLoggedUser = () => {
  let user = {}
  if (isAuthenticated()) {
    user = getLocalStorage(helper.USER_KEY)
  }

  return user
}

export const updateUserPartnerAndUnity = (partnerId, partnerUnitId) => {
  const user = getLocalStorage(helper.USER_KEY)
  const userData = { ...user, partnerId, partnerUnitId }
  saveLocalStorage(helper.USER_KEY, userData)
}
